import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import ViewRecent from "./ViewRecent";
import ViewAllocated from "./ViewAllocated";
import ViewClosed from "./ViewClosed";
import StatusComp from "../../components/StatusComp";

const AdminNotificationsComp = () => {
  const [activeTab, setActiveTab] = useState("Recent");

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("Notifications", JSON.stringify(type));
  };

  const location = useLocation();
  const data = location.state?.data;
  const type = location?.state?.type;

  const navigate = useNavigate();
  const createdAt = moment().format("DD-MM-YYYY");

  return (
    <div className="">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && <ViewRecent site={type} />}
        {activeTab === "Allocated" && <ViewAllocated site={type} />}
        {activeTab === "Closed" && <ViewClosed site={type} />}
      </div>
    </div>
  );
};

export default AdminNotificationsComp;
